import React, { useState, useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';

const ScrollToTopArrow = () => {
  const [isVisible, setIsVisible] = useState(false);
  const controls = useAnimation();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isVisible) {
      controls.start({ opacity: 1, y: 0, display: 'block' });
    } else {
      controls.start({ opacity: 0, y: 20, display: 'none' });
    }
  }, [isVisible, controls]);

  return (
    <motion.button
      className="fixed bottom-8 right-8 z-50 bg-sky-950 hover:bg-sky-900 text-white p-3 rounded-lg shadow-xl focus:outline-none"
      onClick={scrollToTop}
      initial={{ opacity: 0, y: 20, display: 'none' }}
      animate={controls}
      transition={{ ease: 'easeOut', duration: 0.3 }}
      aria-label="Volver arriba"
      title="Volver arriba"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className="w-5 h-5"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M4.5 10.5L12 3m0 0l7.5 7.5M12 3v18"
        />
      </svg>
    </motion.button>
  );
};

export default ScrollToTopArrow;